/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { array, bool, func, string } from 'prop-types';
import GenericSkeleton from '../../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';

const useStyles = (mobile, isFloraVerse) =>
    makeStyles((theme) => ({
        productCardContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            padding: '16px 30px 34px 30px',
            margin: '0 0 24px 0',
            width: '100%',
            height: '100%',
            backgroundColor: `${theme.palette.common.white}`,
            '& > p': {
                textAlign: 'center',
                fontWeight: 700,
                fontSize: `${mobile ? '18px' : '20px'} !important`,
                lineHeight: '26px',
            },
            '& > p:last-of-type': {
                marginBottom: '16px !important',
            },
        },
        title: {
            marginBottom: '16px !important',
        },
        productImage: {
            maxHeight: '240px',
            marginBottom: '16px',
        },
        productName: {
            fontWeight: 500,
            fontSize: `${mobile ? '18px' : '20px'} !important`,
        },
        pdpAnchor: {
            padding: '11px 24px 11px 24px',
            border: `${isFloraVerse ? '#117B91':'#F55858'} !important`,
            borderRadius: '3px',
            textAlign: 'center',
            color: `${isFloraVerse ? '#117B91':'#F55858'} !important`,
            fontSize: `${mobile ? '16px' : '18px'} !important`,
            textDecoration: 'none',
        },
    }));

export const ProductCard = ({
    mobile,
    title,
    productName,
    imageSrc,
    pdpLink,
    priceRange,
    pricePriceText,
    loading,
    handleProductClick,
    isFloraVerse
}) => {
    const classesLayout = useStyles(mobile, isFloraVerse);
    const classes = classesLayout();

    let priceRangeFormatted = !!priceRange.length;

    if (priceRangeFormatted) {
        priceRangeFormatted =
            priceRange.length > 1 ? `$${priceRange?.[0]} - $${priceRange?.[1]}` : `$${priceRange?.[0]?.toFixed(2)}`;
    }

    if (loading) {
        return (
            <div className={classes.productCardContainer}>
                <GenericSkeleton height={'32px'} />
                <GenericSkeleton height={'240px'} />
                <GenericSkeleton height={'48px'} />
            </div>
        );
    }

    return (
        <div className={classes.productCardContainer}>
            <p className={classes.title}>{title}</p>
            <img alt={productName || 'image of product'} className={classes.productImage} src={imageSrc} />
            {!!productName && priceRangeFormatted ? (
                <p>
                    <span className={classes.productName}>{productName}</span>
                    <br />
                    {priceRangeFormatted}
                </p>
            ) : null}
            {pricePriceText && <p>{pricePriceText}</p>}
            <a
                className={classes.pdpAnchor}
                onClick={handleProductClick}
                target={!mobile ? 'target="_blank"' : undefined}
                href={pdpLink}
            >
                Buy Now
            </a>
        </div>
    );
};

ProductCard.defaultProps = {
    title: '',
    productName: '',
    image: '',
    pdpLink: '',
    priceRange: [],
    pricePriceText: '',
    loading: false,
    handleProductClick: () => null,
};

ProductCard.propTypes = {
    mobile: bool.isRequired,
    title: string,
    productName: string,
    image: string,
    pdpLink: string,
    priceRange: array,
    pricePriceText: string,
    loading: bool,
    handleProductClick: func,
};
